import React, { Component } from "react"
import { graphql } from "gatsby"
import "../components/layout.css"
import ContactUs from "../images/contactus-transparent.png"
import { Toast } from "react-bootstrap"
import { RotatingLines } from "react-loader-spinner"

export const query = graphql`
  {
    allDataJson {
      edges {
        node {
          title
          fontFamily
          fontVariants
          primary_color
          contact_detail
          business_id
        }
      }
    }
  }
`

let loadedTimestamp = Date.now()
export default class index extends Component {
  constructor(props) {
    super(props)
    this.state = {
      data: this.props.data,
      senderDetail: {
        senderFullName: "",
        senderMessage: "",
        senderEmail: "",
        senderPhoneNumber: "",
        bot_test_invalid: "",
        bot_test_valid: "this-is-for-bot-test",
      },
      destinationEmail:
        this.props.data.allDataJson.edges[0].node.contact_detail &&
        this.props.data.allDataJson.edges[0].node.contact_detail.email
          ? this.props.data.allDataJson.edges[0].node.contact_detail.email
          : "",
      destinationFullName:
        this.props.data.allDataJson.edges[0].node.contact_detail &&
        this.props.data.allDataJson.edges[0].node.contact_detail.full_name
          ? this.props.data.allDataJson.edges[0].node.contact_detail.full_name
          : "",
      appName: this.props.data.allDataJson.edges[0].node.title
        ? this.props.data.allDataJson.edges[0].node.title
        : "",
      businessId: this.props.data.allDataJson.edges[0].node.business_id
        ? this.props.data.allDataJson.edges[0].node.business_id
        : "",
      toastShow: false,
      toastMessage: "",
      emailInvalid: false,
      loading: false,
    }
    this.changesenderDetail.bind(this)
  }

  onPageLoad = () => {
    loadedTimestamp = Date.now()
    console.log("loaded timestamp", loadedTimestamp)
  }
  componentDidMount() {
    if (
      !this.state.destinationEmail ||
      !this.state.destinationFullName ||
      !this.state.appName
    ) {
      this.setState({ invalidSubmitButton: true })
    }
    if (document.readyState === "complete") {
      this.onPageLoad()
    } else {
      window.addEventListener("load", this.onPageLoad, false)
    }

    console.log(
      "fontFamily",
      this.props.data.allDataJson.edges[0].node.fontFamily,
      this.props.data.allDataJson.edges[0].node.fontVariants
    )
    //     <link rel="preconnect" href="https://fonts.googleapis.com">
    // <link rel="preconnect" href="https://fonts.gstatic.com" crossorigin></link>

    let apiLinkElement = document.createElement("link")
    apiLinkElement.rel = "preconnect"
    apiLinkElement.href = "https://fonts.googleapis.com"
    let gstaticLinkElement = document.createElement("link")
    gstaticLinkElement.rel = "preconnect"
    gstaticLinkElement.href = "https://fonts.gstatic.com"
    gstaticLinkElement.crossOrigin = true
    document.head.appendChild(gstaticLinkElement)
    document.head.appendChild(apiLinkElement)
    let fontFamily = this.props.data.allDataJson.edges[0].node.fontFamily
    let fontVaraints = this.props.data.allDataJson.edges[0].node.fontVariants

    if (fontFamily && fontVaraints) {
      let linkElement = document.createElement("link")
      // linkElement.type = "type/css"
      linkElement.rel = "stylesheet"

      document.head.appendChild(linkElement)
      linkElement.href = generateGoogleFontsUrl(fontFamily, fontVaraints)

      document.documentElement.style.setProperty("--gz-font-family", fontFamily)
    }

    function generateGoogleFontsUrl(fontFamily, variants = []) {
      // Encode the font family name for URL
      const encodedFontFamily = encodeURIComponent(
        fontFamily.replace(/ /g, "+")
      )

      // Join the variants with commas
      let variantString = ""
      let variantTuples = []
      variants.map(v => {
        if (v.includes("italic")) {
          variantTuples.push([
            1,
            v.replace("italic", "") == "" ? "400" : v.replace("italic", ""),
          ])
        } else if (v.includes("regular")) {
          variantTuples.push([0, "400"])
        } else {
          variantTuples.push([0, v])
          // variantString = variantString + `0,${v};`
        }
      })

      variantTuples.sort((a, b) => a[0] - b[0])

      variantTuples.map((v, i) => {
        variantString =
          variantString +
          v.join(",") +
          (variantTuples.length - 1 !== i ? ";" : "")
      })

      // Construct the Google Fonts URL
      const url = `https://fonts.googleapis.com/css2?family=${encodedFontFamily}:ital,wght@${variantString}&display=swap`
      console.log("urls", url, variantTuples)
      return url
    }
  }

  componentWillUnmount() {
    window.removeEventListener("load", this.onPageLoad)
  }

  changesenderDetail(e, key) {
    console.log("event target", e.target.value)
    if (e) {
      if (key == "fullName") {
        this.setState({
          senderDetail: {
            ...this.state.senderDetail,
            senderFullName: e.target.value,
          },
          emptySenderFullname: e.target.value ? false : true,
        })
      } else if (key == "email") {
        this.setState({
          senderDetail: {
            ...this.state.senderDetail,
            senderEmail: e.target.value,
          },
          emailInvalid: e.target.value ? false : true,
        })
      } else if (key == "message") {
        this.setState({
          senderDetail: {
            ...this.state.senderDetail,
            senderMessage: e.target.value,
          },
          emptySenderMessage: e.target.value ? false : true,
        })
      } else if (key == "phoneNumber") {
        let parsedPhoneNumber = e.target.value
        this.setState({
          senderDetail: {
            ...this.state.senderDetail,
            senderPhoneNumber: parsedPhoneNumber,
          },
          emptySenderPhoneNumber: e.target.value ? false : true,
        })
      } else if (key == "bot_test_valid") {
        this.setState({
          senderDetail: {
            ...this.state.senderDetail,
            bot_test_valid: e.target.value,
          },
        })
      } else if (key == "bot_test_invalid") {
        this.setState({
          senderDetail: {
            ...this.state.senderDetail,
            bot_test_invalid: e.target.value,
          },
        })
      }
    }
  }

  submitMessage = async () => {
    var validRegex = new RegExp(
      /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
    )
    console.log(
      "test",
      validRegex.test(this.state.senderDetail.senderEmail),
      this.state.senderDetail
    )
    let submitButtonClicked = true
    let submitTimestamp = Date.now()
    let senderFullNameEmpty,
      senderMessageEmpty,
      senderPhoneNumberEmpty = false
    if (!this.state.senderDetail.senderFullName) {
      senderFullNameEmpty = true
      this.setState({ emptySenderFullname: true })
    }
    if (!this.state.senderDetail.senderPhoneNumber) {
      senderPhoneNumberEmpty = true
      this.setState({ emptySenderPhoneNumber: true })
    }
    if (!this.state.senderDetail.senderMessage) {
      senderMessageEmpty = true
      this.setState({ emptySenderMessage: true })
    }
    this.setState({
      emailInvalid: !validRegex.test(this.state.senderDetail.senderEmail),
    })
    if (
      validRegex.test(this.state.senderDetail.senderEmail) &&
      !senderFullNameEmpty &&
      !senderMessageEmpty &&
      !senderPhoneNumberEmpty
    ) {
      this.setState({ loading: true })
      console.log("timediff", (submitTimestamp - loadedTimestamp) / 1000)
      let submitInfo = {
        senderEmail: this.state.senderDetail.senderEmail,
        senderMessage: this.state.senderDetail.senderMessage,
        senderFullName: this.state.senderDetail.senderFullName,
        senderPhoneNumber: this.state.senderDetail.senderPhoneNumber,
        destinationEmail: this.state.destinationEmail,
        destinationFullName: this.state.destinationFullName,
        appName: this.state.appName,
        botTestInvalid: this.state.senderDetail.bot_test_invalid,
        botTestValid: this.state.senderDetail.bot_test_valid,
        submitButtonClicked: submitButtonClicked,
        submitTimestamp: submitTimestamp,
        loadedTimestamp: loadedTimestamp,
      }
      let envCode =
        window.location.pathname.indexOf("/staging") > -1
          ? "staging"
          : window.location.pathname.indexOf("/prod") > -1
          ? "prod"
          : "local"
      console.log("submitInfo", submitInfo)
      fetch(`/${this.state.businessId}/${envCode}/contactus`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(submitInfo),
      })
        .then(async res => {
          let responseBody = await res.json()
          if (responseBody.status) {
            this.setState({
              senderDetail: {
                ...this.state.senderDetail,
                senderFullName: "",
                senderMessage: "",
                senderEmail: "",
                senderPhoneNumber: "",
              },
              toastShow: true,
              toastMessage: "Message Sent",
              loading: false,
            })
          }
          console.log("response after sending mail", res)
        })
        .catch(err => {
          console.log("error after sending mail", err)
          this.setState({
            loading: false,
            toastShow: true,
            toastMessage: "Error while sending message",
          })
        })
    } else {
      console.log("Invalid Email")
      this.setState({
        emailInvalid: true,
      })
    }
  }

  render() {
    return (
      <>
        {console.log("test values", this.state)}
        {/* <div className="toast_location_contactus">
          <Toast
            onClose={() =>
              this.setState({
                toastDetail: {
                  ...this.state.toastDetail,
                  toastShow: false,
                  toastMessage: "",
                },
              })
            }
            show={this.state.toastDetail.toastShow}
            delay={3000}
            autohide
          >
            <ToastBody>{this.state.toastDetail.toastMessage}</ToastBody>
          </Toast>
        </div> */}
        <div className="toast_location_contactus">
          <Toast
            onClose={() =>
              this.setState({
                toastShow: false,
              })
            }
            show={this.state.toastShow}
            delay={3000}
            autohide
          >
            <Toast.Body>{this.state.toastMessage}</Toast.Body>
          </Toast>
        </div>
        {console.log("color", this.state.data, this.state.senderDetail)}
        <div
          className="contactus_container"
          style={{
            backgroundColor: this.state.data.allDataJson.edges[0].node
              .primary_color,
          }}
        >
          <header
            className="header_main"
            style={{
              backgroundColor: this.state.data.allDataJson.edges[0].node
                .primary_color,
            }}
          >
            {/* <a href="https://growthzilla.com">
              <img
                className="privacy_image"
                src={"https://growthzilla.com/img/growthzilla-logo.png"}
                alt=""
              ></img>
            </a> */}
            <div className="privacy_image"></div>
          </header>
          <div className="contactus_main">
            <h2>Contact Us</h2>{" "}
            <p>Have any queries, Let us know through the form below!</p>
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
              }}
            >
              <div style={{ width: "50%" }}>
                <img
                  src={ContactUs}
                  alt="contact-us.jpg"
                  style={{ width: "100%" }}
                />
              </div>
              <div className="contactus-form">
                <input
                  id="full_name"
                  placeholder="Full Name"
                  style={{
                    borderColor: this.state.emptySenderFullname && "red",
                  }}
                  onChange={e => {
                    this.changesenderDetail(e, "fullName")
                  }}
                  value={this.state.senderDetail.senderFullName}
                />

                <input
                  id="ph_number"
                  style={{
                    borderColor: this.state.emptySenderPhoneNumber && "red",
                  }}
                  placeholder="Phone Number"
                  onChange={e => {
                    this.changesenderDetail(e, "phoneNumber")
                  }}
                  type="number"
                  min={0}
                  value={this.state.senderDetail.senderPhoneNumber}
                />

                <input
                  id="email_address"
                  placeholder="Email Address"
                  style={{ borderColor: this.state.emailInvalid && "red" }}
                  onChange={e => {
                    this.changesenderDetail(e, "email")
                  }}
                  value={this.state.senderDetail.senderEmail}
                />

                <input
                  id="bot_test_valid"
                  placeholder="Bot Test Valid"
                  hidden={true}
                  onChange={e => {
                    this.changesenderDetail(e, "bot_test_valid")
                  }}
                  value={this.state.senderDetail.bot_test_valid}
                />

                <input
                  id="bot_test_invalid"
                  placeholder="Bot Test Invalid"
                  hidden={true}
                  onChange={e => {
                    this.changesenderDetail(e, "bot_test_invalid")
                  }}
                  value={this.state.senderDetail.bot_test_invalid}
                />

                <textarea
                  placeholder="Message"
                  id="message"
                  style={{
                    borderColor: this.state.emptySenderMessage && "red",
                  }}
                  onChange={e => {
                    this.changesenderDetail(e, "message")
                  }}
                  value={this.state.senderDetail.senderMessage}
                />
                <button
                  style={{
                    backgroundColor: !this.state.invalidSubmitButton
                      ? this.state.data.allDataJson.edges[0].node.primary_color
                      : "#ccc",
                  }}
                  onClick={() =>
                    !this.state.invalidSubmitButton && this.submitMessage()
                  }
                >
                  {!this.state.loading ? (
                    "Submit"
                  ) : (
                    <RotatingLines
                      strokeColor="white"
                      strokeWidth="5"
                      animationDuration="0.95"
                      width="30"
                      visible={true}
                    />
                  )}
                </button>
              </div>
            </div>
          </div>
        </div>
      </>
    )
  }
}
